import { AbandonVehicleFeeModalComponent } from '../incident/abv-fee/abandon-vehicle-fee-modal.component';
import { CommonAamvaModalComponent } from '../incident/common-incident/common-incident-modal-aamva.component';
import { CommonModalComponent } from '../incident/common-incident/common-incident-modal.component';
import { AzConvictionIncidentModalComponent } from '../incident/conviction/az/conviction-incident-modal.component';
import { OojConvictionIncidentModalComponent } from '../incident/conviction/out/conviction-incident-ooj-modal.component';
import { CollectionsIncidentModalComponent } from '../incident/finance/collections/collections-incident-modal.component';
import { FinanceModalComponent } from '../incident/finance/finance-modal.component';
import { NsfIncidentModalComponent } from '../incident/finance/nsf/nsf-incident-modal.component';
import { FinancialResponsibilityIncidentModalComponent } from '../incident/financialResponsibility/financial-responsibility-incident-modal.component';
import { FraudCustomerAamvaModalComponent } from '../incident/fraud/fraud-customer-aamva-modal.component';
import { FraudCustomerModalComponent } from '../incident/fraud/fraud-customer-modal.component';
import { FraudVehicleModalComponent } from '../incident/fraud/fraud-vehicle-modal.component';
import { JudgmentIncidentModalComponent } from '../incident/judgment/judgment-incident-modal.component';
import { LawEnforcementIncidentModalComponent } from '../incident/law-enforcement/admin/law-enforcement-incident-modal.component';
import { LawEnforcementIncidentOOJModalComponent } from '../incident/law-enforcement/ooj/law-enforcement-incident-ooj-modal.component';
import { UnderageIncidentModalComponent } from '../incident/law-enforcement/underage/underage-incident-modal.component';
import { MedicalAlertModalComponent } from '../incident/medical-alert/medical-alert-incident-modal.component';
import { IncidentAbandonedVehicle } from '../incident/models/incident-abandoned-vehicle.model';
import { CommonAamvaModel } from '../incident/models/common-aamva.model';
import { CommonModel } from '../incident/models/common.model';
import { IncidentUiType } from '../incident/models/enums/incident-ui-type.enum';
import { FailedVisionModel } from '../incident/models/failed-vision.model';
import { FinanceIncident } from '../incident/models/finance-incident.model';
import { FinancialResponsibilityIncidentModel } from '../incident/models/financial-responsibility-incident.model';
import { FraudAamvaModel } from '../incident/models/fraud-aamva.model';
import { FraudModel } from '../incident/models/fraud.model';
import { IncidentConvictionOojModel } from '../incident/models/incident-conviction-ooj.model';
import { IncidentConvictionModel } from '../incident/models/incident-conviction.model';
import { IncidentFinanceCollectionModel } from '../incident/models/incident-finance-collection.model';
import { IncidentLawEnforcementOOJModel } from '../incident/models/incident-law-enforcement-ooj.model';
import { IncidentLawEnforcementModel } from '../incident/models/incident-law-enforcement.model';
import { IncidentMedicalAlertModel } from '../incident/models/incident-medical-alert.model';
import { IncidentTypeModel } from '../incident/models/incident-type.model';
import { IncidentUnderageAffidavitModel } from '../incident/models/incident-underage-affidavit.model';
import { IncidentModel } from '../incident/models/incident.model';
import { JudgmentIncidentModel } from '../incident/models/judgment-incident.model';
import { MissingRequirementsModel } from '../incident/models/missing-requirements.model';
import { NsfIncidentModel } from '../incident/models/nsf-incident.model';
import { OpsOfLawModel } from '../incident/models/ops-of-law.model';
import { RegistrationModel } from '../incident/models/registration.model';
import { AbandonVehicleModalComponent } from '../incident/registration/abv/abandon-vehicle-modal.component';
import { DocumentIncompleteModalComponent } from '../incident/registration/document-incomplete/document-incomplete-modal.component';
import { FrAccidentModalComponent } from '../incident/registration/fr-accident/fr-accident-modal.component';
import { MandatoryInsuranceModalComponent } from '../incident/registration/insurance/mandatory-insurance-modal.component';
import { OpsOfLawModalComponent } from '../incident/registration/ops-of-law/ops-of-law-modal.component';
import { IncidentDialogContext } from '../incident/shared/incident-dialog-context.model';
import { FailedVisionModalComponent } from '../incident/vision/failed-vision/failed-vision-modal.component';

export function generateIncidentDialogData(selectedIncidentType: IncidentTypeModel, incidentNumberId: number, isReadonly: boolean):
{ componentType: any; data: IncidentDialogContext<IncidentModel> }  {
    const incidentUiTypes: IncidentUiType = new IncidentUiType();
    let innerData: IncidentModel = null;
    let componentType = null;

    switch (selectedIncidentType.incidentUiTypeId) {
        case incidentUiTypes.FraudCustomer.id:
            componentType = FraudCustomerModalComponent;
        case incidentUiTypes.FraudVehicle.id:
            componentType = componentType || FraudVehicleModalComponent;
            innerData = new FraudModel();
            break;

        case incidentUiTypes.AbandonedVehicle.id:
            componentType = AbandonVehicleModalComponent;
        case incidentUiTypes.Tteap.id:
            // componentType = TTEAPModalComponent;
            // innerData = new RegistrationModel();
            innerData = new CommonModel();
            componentType = CommonModalComponent;
        case incidentUiTypes.FinancialResponsibility.id:
            componentType = componentType || FrAccidentModalComponent;
        case incidentUiTypes.FailureToComplyWithCIID.id:
            innerData = new CommonModel();
            componentType = CommonModalComponent;
            break;
        case incidentUiTypes.MandatoryInsurance.id:
            componentType = componentType || MandatoryInsuranceModalComponent;
            innerData = new RegistrationModel();
            break;

        case incidentUiTypes.DocumentIncomplete.id:
            componentType = DocumentIncompleteModalComponent;
            innerData = new MissingRequirementsModel();
            break;

        case incidentUiTypes.OpsOfLawLienVehicle.id:
        case incidentUiTypes.OpsOfLawLienCustomer.id:
            componentType = OpsOfLawModalComponent;
            innerData = new OpsOfLawModel();
            break;

        case incidentUiTypes.AbandonedVehicleFee.id:
            innerData = new IncidentAbandonedVehicle();
            componentType = AbandonVehicleFeeModalComponent;
            break;

        case incidentUiTypes.FinanceCollection.id:
            innerData = new IncidentFinanceCollectionModel();
            componentType = CollectionsIncidentModalComponent;
            break;

        case incidentUiTypes.NSFCancellation.id:
            innerData = new FinanceIncident();
            componentType = FinanceModalComponent;
            break;

        case incidentUiTypes.NsfPenaltyDue.id:
            innerData = new NsfIncidentModel();
            componentType = NsfIncidentModalComponent;
            break;

        case incidentUiTypes.DefaultJudgment.id:
        case incidentUiTypes.NonpaymentOfJudgment.id:
            innerData = new JudgmentIncidentModel();
            componentType = JudgmentIncidentModalComponent;
            break;

        case incidentUiTypes.FinancialResponsibilityCourtOrdered.id:
            innerData = new FinancialResponsibilityIncidentModel();
            componentType = FinancialResponsibilityIncidentModalComponent;
            break;

        case incidentUiTypes.FailedVisionExam.id:
            innerData = new FailedVisionModel();
            componentType = FailedVisionModalComponent;
            break;

        case incidentUiTypes.DLAdmin.id:
            innerData = new CommonAamvaModel();
            componentType = CommonAamvaModalComponent;
            break;

        case incidentUiTypes.MRPIncident.id:
            innerData = new CommonAamvaModel();
            componentType = CommonAamvaModalComponent;
            break;

        case incidentUiTypes.FraudCustomerAAMVA.id:
            innerData = new FraudAamvaModel();
            componentType = FraudCustomerAamvaModalComponent;
            break;

        case incidentUiTypes.CommonIncident.id:
            innerData = new CommonModel();
            componentType = CommonModalComponent;
            break;

        case incidentUiTypes.UnderageIncident.id:
            innerData = new IncidentUnderageAffidavitModel();
            componentType = UnderageIncidentModalComponent;
            break;

        case incidentUiTypes.LawEnforcementIncident.id:
            innerData = new IncidentLawEnforcementModel();
            componentType = LawEnforcementIncidentModalComponent;
            break;

        case incidentUiTypes.OutOfStateLawEnforcement.id:
            innerData = new IncidentLawEnforcementOOJModel();
            componentType = LawEnforcementIncidentOOJModalComponent;
            break;

        case incidentUiTypes.InStateConviction.id:
            innerData = new IncidentConvictionModel();
            componentType = AzConvictionIncidentModalComponent;
            break;

        case incidentUiTypes.OutOfStateConviction.id:
            innerData = new IncidentConvictionOojModel();
            componentType = OojConvictionIncidentModalComponent;
            break;

        case incidentUiTypes.MedicalAlertType.id:
            innerData = new IncidentMedicalAlertModel();
            componentType = MedicalAlertModalComponent;
            break;

        default: break;
    }
    const data: IncidentDialogContext<typeof innerData> = new IncidentDialogContext<typeof innerData>(innerData, isReadonly);

    if (null == data.incident) {
        data.incident = innerData || <IncidentModel> {};
    }

    data.incident.id = incidentNumberId;
    data.incident.incidentNumberId = incidentNumberId;
    data.incident.incidentTypeId = selectedIncidentType.id;
    data.incident.incidentGroupTypeId = selectedIncidentType.incidentGroupTypeId;

    return { componentType, data };
}
